import buttonTheme from './button.theme';
import landingPageTheme from './landing-page.theme';

const theme = {
    ...landingPageTheme,
    ...buttonTheme,
};

export default theme;
